import { combineReducers } from 'redux';
import presentations from './presentations';

const reducers = {
  presentations,
};

export default combineReducers(reducers);
